import { cookieId } from '../constants'

/**
 * Read the experiment cookie.
 * @returns {Object} null if not defined, object with expId and userId
 */
export function readExpCookie() {
  // Find any experiment cookie.
  let allCookies
  let cookieStr
  let it

  let cachedCookie

  // Check the memoized cookie.
  if (cachedCookie) {
    return cachedCookie
  }

  // Perform cookie lookup.
  allCookies = decodeURIComponent(document.cookie).split('; ')
  for (it = 0; it < allCookies.length; it++) {
    cookieStr = allCookies[it]
    // eslint-disable-next-line consumerweb/no-indexof
    if (cookieStr.indexOf(cookieId) === 0) {
      try {
        cachedCookie = JSON.parse(cookieStr.substring(cookieId.length + 1))

        return cachedCookie
      } catch (err) {
        // console.error('Unable to parse experiment cookie.');
      }
    }
  }

  return null
}
